export const getIbanExpectedFormat = (countryCode: string): string => {
  const fallback = 'FR334533**************';
  return countryCode
    ? `${countryCode.toUpperCase()}334533**************`
    : fallback;
};

export const getExpectedFormatHint = (prefix: string, expectedFormat: string): string => {

  return prefix.replace('expected format', expectedFormat);
};
